/**
 * Checks if a value is an empty plain object.
 *
 * @param obj - Value to check
 * @returns True if value is a plain object with no enumerable properties
 *
 * @remarks
 * Arrays, null, and primitives return false.
 *
 * @example
 * ```
 * isEmptyObject({}); // true
 * isEmptyObject({ key: 'value' }); // false
 * isEmptyObject(null); // false
 * isEmptyObject([]); // false
 * ```
 */
export const isEmptyObject = (obj: unknown): boolean =>
  typeof obj === 'object' && obj !== null && !Array.isArray(obj) && Object.keys(obj).length === 0;
